module.exports = __webpack_public_path__ + "static/estate-planning-hero-mobile.e3e9f13c.webp";